function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", {
  id: "forbidden"
}, "Unauthorized");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "7bs3l6n1la",
  x1: "50%",
  x2: "50%",
  y1: "99.978%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: "54%",
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mrq78ulzwb",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: "54%",
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "37xmd6rbxc",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: ".013%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: "54%",
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "gray",
  stopOpacity: 0.1
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 154.855,
  cy: 157.333,
  fill: "#3D84FF",
  fillRule: "nonzero",
  opacity: 0.1,
  rx: 154.855,
  ry: 18.822
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#DCDCDC",
  fillRule: "nonzero",
  d: "M2.636 3.392H193.9c1.456 0 2.636 1.18 2.636 2.636v106.374c0 1.456-1.18 2.636-2.636 2.636H2.636c-1.456 0-2.636-1.18-2.636-2.636V6.028c0-1.456 1.18-2.636 2.636-2.636z",
  transform: "translate(54.085)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F6F5FE",
  fillRule: "nonzero",
  d: "M5.274 1.32h188.098c1.456 0 2.637 1.18 2.637 2.635V110.33c0 1.456-1.18 2.637-2.637 2.637H5.274c-1.455 0-2.636-1.18-2.636-2.637V3.955c0-1.456 1.18-2.636 2.636-2.636z",
  transform: "translate(54.085)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(54.085) translate(22.426 15.83)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#935CF9",
  fillRule: "nonzero",
  d: "M0.614 8.126H89.26400000000001V11.161H0.614z",
  opacity: 0.099
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44.829,
  cy: 9.643,
  r: 5.127,
  fill: "#935CF9",
  fillRule: "nonzero",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17.608,
  cy: 23.458,
  r: 5.127,
  fill: "#935CF9",
  fillRule: "nonzero",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 75.708,
  cy: 37.475,
  r: 5.127,
  fill: "#935CF9",
  fillRule: "nonzero",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34.469,
  cy: 51.289,
  r: 5.127,
  fill: "#935CF9",
  fillRule: "nonzero",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.856,
  cy: 65.103,
  r: 5.127,
  fill: "#935CF9",
  fillRule: "nonzero",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61.691,
  cy: 78.917,
  r: 5.127,
  fill: "#935CF9",
  fillRule: "nonzero",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44.829,
  cy: 9.643,
  r: 3.9,
  fill: "#935CF9",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#935CF9",
  fillRule: "nonzero",
  d: "M0.614 21.997H89.26400000000001V25.032H0.614z",
  opacity: 0.099
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17.52,
  cy: 23.514,
  r: 3.9,
  fill: "#935CF9",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#935CF9",
  fillRule: "nonzero",
  d: "M0.614 35.87H89.26400000000001V38.905H0.614z",
  opacity: 0.099
}), /*#__PURE__*/React.createElement("circle", {
  cx: 75.609,
  cy: 37.388,
  r: 3.9,
  fill: "#935CF9",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#935CF9",
  fillRule: "nonzero",
  d: "M0.614 49.741H89.26400000000001V52.775999999999996H0.614z",
  opacity: 0.099
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34.426,
  cy: 51.259,
  r: 3.9,
  fill: "#935CF9",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#935CF9",
  fillRule: "nonzero",
  d: "M0.614 63.614H89.26400000000001V66.649H0.614z",
  opacity: 0.099
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.767,
  cy: 65.132,
  r: 3.9,
  fill: "#935CF9",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#935CF9",
  fillRule: "nonzero",
  d: "M0.614 77.485H89.26400000000001V80.52H0.614z",
  opacity: 0.099
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61.738,
  cy: 79.003,
  r: 3.9,
  fill: "#935CF9",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#7bs3l6n1la)",
  fillRule: "nonzero",
  d: "M101.618 45.469H115.48899999999999V54.883H101.618zM120.259 45.469H134.13V54.883H120.259z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#24E7B8",
  fillRule: "nonzero",
  d: "M138.9 45.469H152.77100000000002V54.883H138.9z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#7bs3l6n1la)",
  fillRule: "nonzero",
  d: "M101.618 59.775H115.48899999999999V69.189H101.618zM120.259 59.775H134.13V69.189H120.259z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#24E7B8",
  fillRule: "nonzero",
  d: "M138.9 59.775H152.77100000000002V69.189H138.9z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#mrq78ulzwb)",
  fillRule: "nonzero",
  d: "M101.618 74.078H115.48899999999999V83.492H101.618zM120.259 74.078H134.13V83.492H120.259zM138.9 74.078H152.77100000000002V83.492H138.9z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#24E7B8",
  fillRule: "nonzero",
  d: "M102.485 46.056H114.623V54.292H102.485zM121.126 46.056H133.264V54.292H121.126zM139.765 46.056H151.903V54.292H139.765zM102.485 60.362H114.623V68.598H102.485zM121.126 60.362H133.264V68.598H121.126zM139.765 60.362H151.903V68.598H139.765zM102.485 74.667H114.623V82.903H102.485zM121.126 74.667H133.264V82.903H121.126z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3AD29F",
  fillRule: "nonzero",
  d: "M139.765 74.667H151.903V82.903H139.765z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116.732,
  cy: 8.941,
  r: 7.951,
  fill: "url(#37xmd6rbxc)",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116.732,
  cy: 8.941,
  r: 7.454,
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116.732,
  cy: 8.941,
  r: 1.319,
  fill: "#333",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeWidth: 0.55,
  d: "M116.732 8.941L121.203 4.469"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M118.024 8.742c-.001 2.5 1.254 4.835 3.34 6.214 1.913-1.465 3-3.764 2.917-6.172-.082-2.409-1.324-4.628-3.334-5.958-1.843 1.408-2.924 3.596-2.923 5.916z",
  opacity: 0.05
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137.656,
  cy: 8.941,
  r: 7.951,
  fill: "url(#37xmd6rbxc)",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137.656,
  cy: 8.941,
  r: 7.454,
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137.656,
  cy: 8.941,
  r: 1.319,
  fill: "#333",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeWidth: 0.55,
  d: "M137.656 8.941L142.128 4.469"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M138.948 8.742c0 2.5 1.254 4.835 3.34 6.214 1.913-1.465 3-3.764 2.918-6.172-.083-2.409-1.325-4.628-3.334-5.958-1.844 1.408-2.925 3.596-2.924 5.916z",
  opacity: 0.05
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116.732,
  cy: 27.63,
  r: 7.951,
  fill: "url(#37xmd6rbxc)",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116.732,
  cy: 27.63,
  r: 7.454,
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116.732,
  cy: 27.63,
  r: 1.319,
  fill: "#333",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeWidth: 0.55,
  d: "M116.732 27.63L111.978 32.384"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M118.024 27.431c-.001 2.501 1.254 4.835 3.34 6.215 1.913-1.465 3-3.765 2.917-6.173-.082-2.408-1.324-4.627-3.334-5.957-1.843 1.408-2.924 3.595-2.923 5.915z",
  opacity: 0.05
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137.656,
  cy: 27.63,
  r: 7.951,
  fill: "url(#37xmd6rbxc)",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137.656,
  cy: 27.63,
  r: 7.454,
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137.656,
  cy: 27.63,
  r: 1.319,
  fill: "#333",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeWidth: 0.55,
  d: "M137.656 27.63L142.128 23.159"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M138.948 27.431c0 2.501 1.254 4.835 3.34 6.215 1.913-1.465 3-3.765 2.918-6.173-.083-2.408-1.325-4.627-3.334-5.957-1.844 1.408-2.925 3.595-2.924 5.915z",
  opacity: 0.05
})), /*#__PURE__*/React.createElement("path", {
  fill: "#434957",
  fillRule: "nonzero",
  d: "M195.521 0H1.015C.455 0 0 .455 0 1.015v4.291h196.528v-4.29c0-.558-.45-1.011-1.007-1.016z",
  transform: "translate(54.085)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero",
  transform: "translate(54.085) translate(4.717 1.214)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.387,
  cy: 1.439,
  r: 1.372
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5.08,
  cy: 1.439,
  r: 1.372
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8.774,
  cy: 1.439,
  r: 1.372
})), /*#__PURE__*/React.createElement("g", {
  fill: "#3D84FF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48.646 24.2h-4.062v-7.848c0-8.855-7.1-16.217-16.005-16.351-4.337-.045-8.513 1.633-11.6 4.662-3.088 3.029-4.832 7.158-4.845 11.472V24.2H8.08c-3.73.012-6.75 3.015-6.76 6.724V63.19c.01 3.709 3.03 6.712 6.76 6.724h40.566c3.729-.012 6.748-3.016 6.758-6.724V30.924c-.01-3.708-3.029-6.712-6.758-6.724zm-18.73 20.052v11.377c.007 1.25-.95 2.292-2.192 2.383-.63.03-1.246-.201-1.703-.64-.456-.437-.715-1.044-.715-1.679V44.246c-2.2-1.079-3.37-3.54-2.819-5.937.551-2.397 2.675-4.095 5.124-4.095 2.448 0 4.572 1.698 5.123 4.095.55 2.397-.618 4.858-2.819 5.937v.006zM38.877 23.8H16.343V15.8c0-6.261 5.043-11.337 11.263-11.337S38.87 9.539 38.87 15.8l.01 8z",
  opacity: 0.34,
  transform: "translate(54.085) translate(159.617 55.404)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.327 24.2h-4.063v-7.848c0-8.855-7.1-16.217-16.004-16.351-4.337-.045-8.513 1.633-11.6 4.662-3.088 3.029-4.832 7.158-4.845 11.472V24.2H6.76c-3.73.012-6.75 3.015-6.761 6.724V63.19c.012 3.709 3.032 6.712 6.761 6.724h40.566c3.729-.012 6.748-3.016 6.758-6.724V30.924c-.01-3.708-3.03-6.712-6.758-6.724zM28.596 44.252v11.377c.008 1.25-.95 2.292-2.19 2.383-.631.03-1.247-.201-1.704-.64-.457-.437-.715-1.044-.715-1.679V44.246c-2.2-1.079-3.37-3.54-2.819-5.937.551-2.397 2.675-4.095 5.123-4.095 2.449 0 4.573 1.698 5.123 4.095.551 2.397-.618 4.858-2.818 5.937v.006zM37.559 23.8H15.024V15.8c0-6.261 5.042-11.337 11.263-11.337 6.22 0 11.263 5.076 11.263 11.337l.01 8z",
  transform: "translate(54.085) translate(159.617 55.404)"
}))));

function SvgForbidden(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    width: 310,
    height: 177,
    viewBox: "0 0 310 177",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbidden);
export default __webpack_public_path__ + "static/media/forbidden.727f847a902060e0bd0d41211cf05694.svg";
export { ForwardRef as ReactComponent };